import { SavingsContainer } from '@/features/savings/SavingsContainer'

export function Savings() {
  return <SavingsContainer />
}
